<script lang="ts">
  export let svgStyles: string = ''
</script>

<svg viewBox="0 0 798 798" fill="none" xmlns="http://www.w3.org/2000/svg" class={svgStyles}>
  <circle cx="398.757" cy="398.757" r="398.079" stroke="url(#paint0_linear_6241_2131)" stroke-width="0.841605" />
  <defs>
    <linearGradient
      id="paint0_linear_6241_2131"
      x1="115.688"
      y1="87.8456"
      x2="706.188"
      y2="797.257"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#24CAFF" />
      <stop offset="0.7" stop-color="#FDB1A8" />
      <stop offset="1" stop-color="#FFA564" />
    </linearGradient>
  </defs>
</svg>
